import React, { Component } from 'react'
import OutpatientAppointment from './outpatientAppointment'

class OutpatientAppointmentScreen extends Component {
  render() {
    return (
      <div>
        <OutpatientAppointment {...this.props} />
      </div>
    )
  }
}

export default OutpatientAppointment


// WEBPACK FOOTER //
// ./src/modules/appointment/components/index.js